// Table.js
import React from 'react';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

const Table = ({ columns, data, onCenter }) => (
    <table className="table table-bordered table-sm ueColorBase">
        <TableHeader columns={columns} />
        <tbody>
            {data.map((item, index) => (
                <TableRow key={index} item={item} columns={columns} onCenter={onCenter} />
            ))}
        </tbody>
    </table>
);

export default React.memo(Table);
